import React from 'react';
import { Box, Autocomplete, TextField } from '@mui/material';
import { fonts, colors } from '../../../../constants';
import { PRIORITY_OPTIONS } from '../../../../constants/raiseQueryForm';
import FormFieldLabel from '../FormFieldLabel';
import { getSelectStyle } from '../../../../utils/formUtils';

/**
 * PriorityField Component
 * Priority selection field
 */
const PriorityField = ({
  formData,
  focusedFields,
  priorities = PRIORITY_OPTIONS,
  handleChange,
  handleFocus,
  handleBlur,
}) => {
  const getSelectStyleWithFocus = (field, hasError) => {
    const isFocused = focusedFields[field];
    return getSelectStyle(field, hasError, isFocused);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <FormFieldLabel label="Priority" />
      <Autocomplete
        options={priorities}
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={formData.priority ? priorities.find((opt) => opt.value === formData.priority) || null : null}
        onChange={(event, newValue) => {
          const value = newValue ? newValue.value : '';
          handleChange('priority')({ target: { value } });
        }}
        onFocus={handleFocus('priority')}
        onBlur={handleBlur('priority')}
        openOnFocus
        filterOptions={(options, params) => {
          const filtered = options.filter((option) =>
            option.label.toLowerCase().includes(params.inputValue.toLowerCase())
          );
          return filtered;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              readOnly: false,
              autoComplete: 'off',
            }}
            placeholder="Select a priority"
            sx={{
              '& .MuiOutlinedInput-root': {
                ...getSelectStyleWithFocus('priority', false),
                padding: '4px 9px',
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
              '& .MuiInputBase-input': {
                padding: '8px 4px',
                fontSize: fonts.fontSizeMd,
                cursor: 'text',
              },
            }}
          />
        )}
        sx={{
          width: '100%',
          '& .MuiAutocomplete-inputRoot': {
            padding: '0 !important',
          },
          '& .MuiSvgIcon-root': {
            color: '#1b2538',
          },
          '& .MuiAutocomplete-tag': {
          backgroundColor: colors.primaryTint,
          color: colors.primaryDark,
          },
          '& .MuiAutocomplete-option': {
            '&.Mui-focused': {
            backgroundColor: colors.primaryTint,
            },
            '&[aria-selected="true"]': {
            backgroundColor: colors.primaryTintHover,
              '&.Mui-focused': {
              backgroundColor: colors.primaryTintHover,
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default PriorityField;
